<template>
  <generic-modal :title="$t('function')" ref="generic_modal" size="fullscreen">
    <form>
      <div class="field">
        <label class="label">{{ $t("name") }}</label>
        <input
          class="input"
          type="text"
          :placeholder="$t('function name')"
          v-model="meta.name"
        />
      </div>

      <div class="tabs is-toggle is-fullwidth" ref="tabs">
        <ul>
          <li
            class="is-active"
            data-tab="parameters"
            @click="change_active_tab($event, this)"
          >
            <a>
              <i class="list icon" aria-hidden="true"></i>
              <span>{{ $t("parameters") }}</span>
            </a>
          </li>
          <li data-tab="logic" @click="change_active_tab($event, this)">
            <a>
              <i class="js icon" aria-hidden="true"></i>
              <span>{{ $t("function logic") }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="is-fluid" ref="contents">
        <div class="" data-tab="parameters">
          <div class="field" v-if="meta.settings">
            <label class="label">{{ $t("parameters") }}</label>
            <vue-monaco-editor
              v-model:value="meta.settings.parameters"
              theme="vs-dark"
              language="json"
              :options="{
                automaticLayout: true,
                formatOnType: true,
                formatOnPaste: true,
                tabSize: 2,
                scrollBeyondLastLine: false,
                folding: true,
                bracketPairColorization: true,
                autoClosingBrackets: 'always',
                autoIndent: 'full',
              }"
              style="height: 500px"
            />
          </div>
        </div>
        <div class="is-hidden" data-tab="logic">
          <article class="message is-info">
            <div class="message-header">
              <p>{{ $t("information") }}</p>
            </div>
            <div class="message-body">
              <p>
                {{ $t("use resolve function to return the result") }}
              </p>
            </div>
          </article>
          <div class="field" v-if="meta.settings">
            <label class="label">{{ $t("function logic") }}</label>
            <vue-monaco-editor
              v-model:value="meta.settings.body"
              theme="vs-dark"
              language="javascript"
              :options="{
                automaticLayout: true,
                formatOnType: true,
                formatOnPaste: true,
                tabSize: 2,
                scrollBeyondLastLine: false,
                folding: true,
                bracketPairColorization: true,
                autoClosingBrackets: 'always',
                autoIndent: 'full',
              }"
              style="height: 500px"
            />
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  change_active_tab,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import { VueMonacoEditor } from "@guolao/vue-monaco-editor";

export default {
  name: "FunctionModal",
  components: { GenericModal, VueMonacoEditor },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name || !v.meta.settings || !v.meta.settings.body;
    },
  },
  methods: {
    change_active_tab,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/assistant/function", { uuid: uuid })
        .then((element) => {
          v.meta = element;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = {
        ...v.meta,
      };
      if (!v.meta.uuid)
        put("/assistant/function", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/assistant/function", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {
          parameters: "",
          body: "",
        },
      };
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
